import UnsavedChangesModal from './UnsavedChangesModal';

export { default as UnsavedChangesModalV2 } from './UnsavedChangesModalV2';

export default UnsavedChangesModal;
